/* Galerie & Kunsthaus Nottbohm — individuelle Ergänzungen
   A) Produktseiten: Anfragebuttons mit Übergabe der Werkdaten
   B) Kontaktseite: Betreff und Nachricht vorbelegen
   C) Kollektionsseiten: Kopfbereich, Künstlerprofil, Mosaik, Filterleiste
   D) Werkseiten: „Zuletzt angesehen“ im selben Mosaik

   Zum Raster: Jede Werkkachel des Themes trägt die Klasse .product-card.
   Auf Künstlerseiten entsteht ab vier Werken das Mosaik, darunter das
   schlichte Raster mit der Profilkachel links. Auf Werkseiten wird
   „Zuletzt angesehen“ mit denselben Regeln gesetzt — dort ohne
   Profilkachel und immer als Mosaik.

   Zur Reihenfolge: Ein Werk belegt je nach Seitenverhältnis eine, zwei
   oder drei Spalten. Gepackt wird zeilenweise, gewählt wird jeweils das
   breiteste Werk, das noch in die Zeile passt. Querformate kommen
   dadurch nach vorn und werden mit einem Hochformat aufgefüllt.

   Serienware mit Versandpauschale (window.nottbohmWerk.versandpauschale,
   gesetzt in snippets/nottbohm-anfrage.liquid) bekommt keinen Knopf
   „Unverbindlich anfragen“: Preis und Versand stehen fest, es gibt nichts
   anzufragen. Stattdessen nennt die Zeile unter dem Preis den Betrag
   (versandkurz) statt nur „zzgl. Versandkosten“.
   Nicht Teil des Impression-Themes.
*/
(function () {
	"use strict";

	var KONTAKT = "/pages/contact";
	var W = window.nottbohmWerk || null;
	var K = window.nottbohmKollektion || null;
	var MOSAIK_AB = 4;
	var RASTERNAME = /(grid|products|product-list|collection__list|plp)/i;
	var HINWEIS_VORGABE = "Wir melden uns persönlich – auf Wunsch mit einem Angebot für Einrahmung und Lieferung.";

	var TEXTE = {
		Kaufanfrage: "ich interessiere mich für dieses Werk und bitte um ein Angebot",
		Einrahmung: "ich interessiere mich für eine Einrahmung dieses Werks",
		Lieferung: "ich möchte die Lieferung dieses Werks anfragen",
		Anfrage: "ich habe eine Frage zu diesem Werk"
	};

	function istKollektionsseite() {
		var p = window.location.pathname;
		if (p.indexOf("/products/") > -1) return false;
		return /\/collections\/[^\/]+/.test(p);
	}

	function istWerkseite() {
		return window.location.pathname.indexOf("/products/") > -1;
	}

	function kollektionsname() {
		if (K && K.titel) return K.titel;
		var h1 = document.querySelector("h1");
		return h1 ? h1.textContent.trim() : "";
	}

	/* ---------- A) Produktseiten ---------- */

	function anliegenErkennen(text) {
		var t = (text || "").toLowerCase();
		if (t.indexOf("einrahmung") > -1) return "Einrahmung";
		if (t.indexOf("lieferung") > -1) return "Lieferung";
		if (t.indexOf("unverbindlich") > -1) return "Kaufanfrage";
		return "Anfrage";
	}

	function zieladresse(anliegen) {
		var u = new URL(KONTAKT, window.location.origin);
		u.searchParams.set("anliegen", anliegen);
		u.searchParams.set("werk", W.titel);
		if (W.kuenstler) u.searchParams.set("kuenstler", W.kuenstler);
		if (W.sku) u.searchParams.set("sku", W.sku);
		return u.pathname + u.search;
	}

	function linksErgaenzen() {
		if (!W || !W.titel) return;
		var links = document.querySelectorAll('a[href*="' + KONTAKT + '"]:not([data-nb])');
		Array.prototype.forEach.call(links, function (a) {
			a.setAttribute("data-nb", "1");
			var url;
			try { url = new URL(a.getAttribute("href"), window.location.origin); } catch (e) { return; }
			if (url.searchParams.get("werk")) return;
			if (!url.searchParams.get("anliegen")) {
				url.searchParams.set("anliegen", anliegenErkennen(a.textContent));
			}
			url.searchParams.set("werk", W.titel);
			if (W.kuenstler) url.searchParams.set("kuenstler", W.kuenstler);
			if (W.sku) url.searchParams.set("sku", W.sku);
			a.setAttribute("href", url.pathname + url.search);
		});
	}

	/* Steht der Versand fest, nennt die Zeile unter dem Preis den Betrag.
	   Der Link auf die Seite „Versand und Zahlung“ bleibt erhalten. */
	function versandzeile() {
		if (!W || !W.versandpauschale || !W.versandkurz) return;
		var links = document.querySelectorAll('a[href*="/pages/versand-und-zahlung"]:not([data-nb-versand])');
		Array.prototype.forEach.call(links, function (a) {
			var t = (a.textContent || "").replace(/\s+/g, " ").trim();
			if (!/^zzgl\.?\s*versandkosten$/i.test(t)) return;
			a.setAttribute("data-nb-versand", "1");
			a.textContent = W.versandkurz;
		});
	}

	function sichtbaresKaufformular() {
		var f = document.querySelectorAll('form[action*="/cart/add"]');
		for (var i = 0; i < f.length; i++) if (f[i].offsetParent !== null) return f[i];
		return null;
	}

	function anfragebutton() {
		if (!W || !W.titel || !W.verfuegbar) return;
		if (W.versandpauschale) return;
		if (document.querySelector(".nb-anfrage")) return;
		var formular = sichtbaresKaufformular();
		if (!formular) return;
		var kaufen = formular.querySelector('[name="add"], button[type="submit"]');
		if (!kaufen) return;
		var box = document.createElement("div");
		box.className = "nb-anfrage";
		var a = document.createElement("a");
		a.setAttribute("href", zieladresse("Kaufanfrage"));
		a.setAttribute("data-nb", "1");
		a.className = "nb-anfrage-button";
		a.textContent = "Unverbindlich anfragen";
		var hinweis = document.createElement("p");
		hinweis.className = "nb-anfrage-hinweis";
		hinweis.textContent = (W.anfrageHinweis && String(W.anfrageHinweis).trim()) || HINWEIS_VORGABE;
		box.appendChild(a);
		box.appendChild(hinweis);
		var anker = kaufen.closest("div") || kaufen;
		anker.parentNode.insertBefore(box, anker.nextSibling);
	}

	/* ---------- B) Kontaktseite ---------- */

	function formularVorbelegen() {
		var p = new URLSearchParams(window.location.search);
		var werk = p.get("werk");
		if (!werk) return;
		var anliegen = p.get("anliegen");
		if (!TEXTE[anliegen]) anliegen = "Anfrage";

		var betreff = document.querySelector('input[name*="subject" i], input[name*="betreff" i]');
		if (betreff && !betreff.value) {
			betreff.value = anliegen + ": " + werk;
			betreff.dispatchEvent(new Event("input", { bubbles: true }));
		}

		var zeilen = ["Guten Tag,", "", TEXTE[anliegen] + ":", "", "Werk: " + werk];
		if (p.get("kuenstler")) zeilen.push("Künstler: " + p.get("kuenstler"));
		if (p.get("sku")) zeilen.push("Werknummer: " + p.get("sku"));
		zeilen.push("", "");

		var feld = document.querySelector('textarea[name="contact[body]"], form[action*="/contact"] textarea');
		if (feld && !feld.value) {
			feld.value = zeilen.join("\n");
			feld.dispatchEvent(new Event("input", { bubbles: true }));
		}
	}

	/* ---------- C) Raster ---------- */

	function kopfKompakt() {
		if (!istKollektionsseite()) return;
		var h1 = document.querySelector("h1");
		if (!h1) return;
		var abschnitt = h1.closest('[id^="shopify-section"]') || h1.closest("section");
		if (abschnitt) abschnitt.classList.add("nb-kollektionskopf");
	}

	function werkkacheln() {
		var roh = document.querySelectorAll(".product-card");
		var karten = [];
		Array.prototype.forEach.call(roh, function (k) {
			if (k.closest("header") || k.closest("footer")) return;
			if (k.closest(".nb-kuenstlertext")) return;
			if (!k.querySelector('a[href*="/products/"]')) return;
			karten.push(k);
		});
		return karten;
	}

	function istRaster(el) {
		var d = window.getComputedStyle(el).display;
		return d.indexOf("grid") > -1 || d.indexOf("flex") > -1;
	}

	function rasterZuKacheln(karten) {
		var gesamt = karten.length;
		if (!gesamt) return null;

		var kandidaten = [];
		var el = karten[0].parentElement;
		while (el && el !== document.body && el.tagName !== "MAIN") {
			if (el.querySelectorAll(".product-card").length === gesamt) kandidaten.push(el);
			el = el.parentElement;
		}
		if (!kandidaten.length) return null;

		var i;
		for (i = 0; i < kandidaten.length; i++) {
			var name = kandidaten[i].className || "";
			if (typeof name === "string" && RASTERNAME.test(name)) return kandidaten[i];
		}
		for (i = 0; i < kandidaten.length; i++) {
			if (istRaster(kandidaten[i])) return kandidaten[i];
		}
		for (i = 0; i < kandidaten.length; i++) {
			if (kandidaten[i].children.length === gesamt) return kandidaten[i];
		}
		return kandidaten[0];
	}

	function mosaik() {
		if (!istKollektionsseite() && !istWerkseite()) return null;
		var vorhanden = document.querySelector(".nb-mosaik");
		if (vorhanden) return vorhanden;

		var karten = werkkacheln();
		var behaelter = rasterZuKacheln(karten);
		if (!behaelter) return null;

		behaelter.classList.add("nb-mosaik");

		/* Auf der Werkseite gibt es keine Profilkachel — dort immer Mosaik. */
		if (istKollektionsseite() && karten.length < MOSAIK_AB) {
			behaelter.classList.add("nb-mosaik--wenige");
		} else {
			behaelter.classList.remove("nb-mosaik--wenige");
		}
		return behaelter;
	}

	function filterleiste(raster) {
		if (!raster || !istKollektionsseite()) return;
		var knoten = raster;
		while (knoten && knoten.parentElement) {
			var vorher = knoten.previousElementSibling;
			while (vorher) {
				var hatBedienelement = vorher.querySelector("select, button, [role='button'], input");
				var hatWerk = vorher.querySelector('a[href*="/products/"]');
				if (hatBedienelement && !hatWerk && !vorher.classList.contains("nb-raster-titel")) {
					vorher.classList.add("nb-filterleiste");
				}
				vorher = vorher.previousElementSibling;
			}
			if (knoten.parentElement.tagName === "MAIN" || knoten.parentElement === document.body) break;
			knoten = knoten.parentElement;
		}
	}

	function rasterUeberschrift(raster) {
		if (!raster || !istKollektionsseite()) return;
		if (document.querySelector(".nb-raster-titel")) return;
		var name = kollektionsname();
		if (!name) return;
		var h2 = document.createElement("h2");
		h2.className = "nb-raster-titel";
		h2.textContent = name;
		raster.parentNode.insertBefore(h2, raster);
	}

	function kuenstlerkachel(raster) {
		if (!K || !istKollektionsseite()) return;
		if (document.querySelector(".nb-kuenstler")) return;

		var roh = document.createElement("div");
		roh.innerHTML = K.beschreibung || "";
		var volltext = (roh.textContent || "").replace(/\s+/g, " ").trim();
		var text = (K.kurztext || "").trim() || volltext;
		if (!text && !K.bild) return;

		var kachel = document.createElement("div");
		kachel.className = "nb-kuenstler";

		if (K.bild) {
			var bild = document.createElement("img");
			bild.className = "nb-kuenstler-bild";
			bild.src = K.bild;
			bild.alt = K.titel;
			kachel.appendChild(bild);
		}

		if (text) {
			var teaser = document.createElement("p");
			teaser.className = "nb-kuenstler-teaser";
			teaser.textContent = text;
			kachel.appendChild(teaser);
		}

		if (volltext) {
			var mehr = document.createElement("a");
			mehr.className = "nb-kuenstler-mehr";
			mehr.href = "#kuenstlertext";
			mehr.textContent = "Mehr über " + K.titel;
			kachel.appendChild(mehr);
		}

		if (raster) {
			raster.insertBefore(kachel, raster.firstChild);
		} else {
			var h1 = document.querySelector("h1");
			if (!h1) return;
			h1.parentNode.insertBefore(kachel, h1.nextSibling);
		}

		if (!volltext) return;
		var unten = document.createElement("section");
		unten.className = "nb-kuenstlertext";
		unten.id = "kuenstlertext";
		var h2 = document.createElement("h2");
		h2.textContent = "Über " + K.titel;
		var inhalt = document.createElement("div");
		inhalt.className = "nb-kuenstlertext-inhalt";
		inhalt.innerHTML = K.beschreibung;
		unten.appendChild(h2);
		unten.appendChild(inhalt);
		(document.querySelector("main") || document.body).appendChild(unten);
	}

	function spannweite(verhaeltnis, spalten) {
		if (spalten >= 3) {
			if (verhaeltnis > 2.2) return 3;
			if (verhaeltnis > 1.3) return 2;
			return 1;
		}
		if (spalten === 2 && verhaeltnis > 1.5) return 2;
		return 1;
	}

	function breiteVon(kind, spalten) {
		if (kind.classList.contains("nb-kuenstler")) return 1;
		var bild = kind.querySelector("img");
		if (!bild || !bild.naturalWidth || !bild.naturalHeight) return 1;
		return spannweite(bild.naturalWidth / bild.naturalHeight, spalten);
	}

	function packen(kinder, breiten, spalten) {
		var offen = kinder.slice();
		var rest = breiten.slice();
		var ergebnis = [];

		for (var i = 0; i < offen.length; i++) {
			if (offen[i].classList.contains("nb-kuenstler")) {
				ergebnis.push(offen[i]);
				offen.splice(i, 1);
				rest.splice(i, 1);
				break;
			}
		}
		var platz = ergebnis.length ? spalten - 1 : spalten;

		while (offen.length) {
			if (platz <= 0) platz = spalten;
			var treffer = -1, beste = 0;
			for (var n = 0; n < offen.length; n++) {
				if (rest[n] <= platz && rest[n] > beste) {
					beste = rest[n];
					treffer = n;
					if (beste === platz) break;
				}
			}
			if (treffer === -1) {
				if (platz === spalten) { treffer = 0; }
				else { platz = spalten; continue; }
			}
			ergebnis.push(offen[treffer]);
			platz -= rest[treffer];
			offen.splice(treffer, 1);
			rest.splice(treffer, 1);
		}
		return ergebnis;
	}

	var sortiertGerade = false;

	function ausrichten() {
		var raster = document.querySelector(".nb-mosaik");
		if (!raster || sortiertGerade) return;

		if (raster.classList.contains("nb-mosaik--wenige")) {
			Array.prototype.forEach.call(raster.children, function (kind) {
				kind.style.gridColumnEnd = "";
				kind.style.gridRowEnd = "";
			});
			return;
		}

		var stil = window.getComputedStyle(raster);
		var zeile = parseFloat(stil.getPropertyValue("grid-auto-rows")) || 8;
		var luecke = parseFloat(stil.getPropertyValue("row-gap")) || 0;
		var spalten = (stil.getPropertyValue("grid-template-columns") || "").trim().split(/\s+/).length;
		var kinder = Array.prototype.slice.call(raster.children);
		var breiten = kinder.map(function (kind) { return breiteVon(kind, spalten); });

		var sortiert = packen(kinder, breiten, spalten);
		var anders = sortiert.some(function (kind, i) { return kind !== kinder[i]; });
		if (anders) {
			sortiertGerade = true;
			sortiert.forEach(function (kind) { raster.appendChild(kind); });
			sortiertGerade = false;
			kinder = sortiert;
			breiten = kinder.map(function (kind) { return breiteVon(kind, spalten); });
		}

		kinder.forEach(function (kind, i) {
			kind.style.gridColumnEnd = breiten[i] > 1 ? "span " + breiten[i] : "";
			kind.style.gridRowEnd = "span 1";
		});

		var hoehen = kinder.map(function (kind) {
			var innen = kind.firstElementChild;
			var h = innen ? innen.getBoundingClientRect().height : 0;
			return Math.max(h, kind.scrollHeight || 0);
		});

		kinder.forEach(function (kind, i) {
			var h = hoehen[i];
			if (!h) { kind.style.gridRowEnd = ""; return; }
			kind.style.gridRowEnd = "span " + Math.max(1, Math.ceil((h + luecke) / (zeile + luecke)));
		});
	}

	function bilderBeobachten(raster) {
		if (!raster) return;
		var bilder = raster.querySelectorAll("img:not([data-nb-bild])");
		Array.prototype.forEach.call(bilder, function (b) {
			b.setAttribute("data-nb-bild", "1");
			if (b.complete) return;
			b.addEventListener("load", ausrichten, { once: true });
			b.addEventListener("error", ausrichten, { once: true });
		});
	}

	/* ---------- Start ---------- */

	function start() {
		linksErgaenzen();
		versandzeile();
		anfragebutton();
		formularVorbelegen();
		kopfKompakt();
		var raster = mosaik();
		filterleiste(raster);
		rasterUeberschrift(raster);
		kuenstlerkachel(raster);
		if (raster) {
			bilderBeobachten(raster);
			ausrichten();
		}
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", start);
	} else {
		start();
	}

	window.addEventListener("load", function () { start(); ausrichten(); });

	var warteResize;
	window.addEventListener("resize", function () {
		window.clearTimeout(warteResize);
		warteResize = window.setTimeout(ausrichten, 200);
	});

	if (window.MutationObserver) {
		var wartet = false;
		new MutationObserver(function () {
			if (wartet || sortiertGerade) return;
			wartet = true;
			window.setTimeout(function () { wartet = false; start(); }, 300);
		}).observe(document.body, { childList: true, subtree: true });
	}
})();
